import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import PerformanceHistory from './PerformanceHistory';
import RatingMetrics from './RatingMetrics';

const DrivePerformanceChart = () => {
  const { jsonData } = useParams();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  const driverId = objectFyData?.id;

  return (
    <Container>
      <PerformanceHistory
        baseUrl={`api/v1/dispatchers/${driverId}/performance-insights?isLookup=true`}
      />
      <RatingMetrics
        baseUrl={`api/v1/dispatchers/${driverId}/rating-metrics?isLookup=true`}
      />
    </Container>
  );
};

export default DrivePerformanceChart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
